// extracted by mini-css-extract-plugin
export default {"button":"style_button__gQ90F","button_primary":"style_button_primary__XxCDd","button_space":"style_button_space__aZYm6","loadingIcon":"style_loadingIcon__43Pvk"};